import * as React from "react";
import { Route, Routes } from "react-router-dom";

import { Footer } from "../Footer";
import { LogoIcon } from "../Logo";
import { Post_250530_HTTP2Preface } from "./Post_250530_HTTP2Preface";
import { Post_250610_GRPCDebugging } from "./Post_250610_GRPCDebugging";
import AdhityaaProfilePicture from "../../images/adtac_profile_picture.jpg";

export const BlogPage = () => {
  return (
    <div className="bg-[#09090b] xl:bg-transparent min-h-screen w-full flex flex-col px-4 lg:px-0 relative">
      <div className="z-[-100] absolute top-0 left-0 w-full h-full hidden xl:flex justify-center items-center">
        <div className="w-full h-full max-w-[1200px] bg-zinc-950 border-l border-r border-zinc-900"></div>
      </div>

      <div className="z-[2] -mx-4 lg:mx-0 w-[calc(100%+32px)] lg:w-full h-[48px] flex justify-center sticky top-0">
        <div className="bg-[#09090b] h-full w-full max-w-[1200px] xl:border-x border-b border-zinc-900 flex justify-between items-center px-[36px] md:px-[72px]">
          <div className="flex justify-center items-center space-x-[80px]">
            <a href="/" className="p-1 -m-1 flex items-center space-x-1 text-zinc-200 hover:text-zinc-100 hover:brightness-[1.10]">
              <LogoIcon className="w-[16px] h-[16px]" />
              <span className="select-none font-medium font-mono text-[10px]">subtrace</span>
            </a>
            <div className="hidden lg:flex justify-center items-center text-[10px]">
              <a href="/pricing" className="flex font-mono items-center px-3 py-2 space-x-1 text-zinc-400 hover:text-zinc-200 hover:brightness-[1.10]">
                /pricing
              </a>
              <a href="/docs" className="flex font-mono items-center px-3 py-2 space-x-1 text-zinc-400 hover:text-zinc-200 hover:brightness-[1.10]">
                /docs
              </a>
              <a href="/customers" className="flex font-mono items-center px-3 py-2 space-x-1 text-zinc-400 hover:text-zinc-200 hover:brightness-[1.10]">
                /customers
              </a>
              <a href="/blog" className="flex font-mono items-center px-3 py-2 space-x-1 text-zinc-400 hover:text-zinc-200 hover:brightness-[1.10]">
                /blog
              </a>
              <a href="/discord" className="flex font-mono items-center px-3 py-2 space-x-1 text-zinc-400 hover:text-zinc-200 hover:brightness-[1.10]">
                /discord
              </a>
            </div>
          </div>
          <div className="flex justify-center items-center space-x-[10px]">
            <a
              target="_blank"
              href="https://github.com/subtrace/subtrace"
              className="h-[32px] flex justify-center items-center space-x-2 rounded bg-transparent transition-bg duration-[150ms] ease-in-out text-zinc-300 hover:text-zinc-100 hover:bg-zinc-900 px-[10px]"
            >
              <svg
                className="w-[16px] h-[16px]"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                focusable="false"
                viewBox="0 0 24 24"
                display="inline-block"
                overflow="visible"
              >
                <path
                  fill="currentColor"
                  d="M12.5.75C6.146.75 1 5.896 1 12.25c0 5.089 3.292 9.387 7.863 10.91.575.101.79-.244.79-.546 0-.273-.014-1.178-.014-2.142-2.889.532-3.636-.704-3.866-1.35-.13-.331-.69-1.352-1.18-1.625-.402-.216-.977-.748-.014-.762.906-.014 1.553.834 1.769 1.179 1.035 1.74 2.688 1.25 3.349.948.1-.747.402-1.25.733-1.538-2.559-.287-5.232-1.279-5.232-5.678 0-1.25.445-2.285 1.178-3.09-.115-.288-.517-1.467.115-3.048 0 0 .963-.302 3.163 1.179.92-.259 1.897-.388 2.875-.388.977 0 1.955.13 2.875.388 2.2-1.495 3.162-1.179 3.162-1.179.633 1.581.23 2.76.115 3.048.733.805 1.179 1.825 1.179 3.09 0 4.413-2.688 5.39-5.247 5.678.417.36.776 1.05.776 2.128 0 1.538-.014 2.774-.014 3.162 0 .302.216.662.79.547C20.709 21.637 24 17.324 24 12.25 24 5.896 18.854.75 12.5.75Z"
                ></path>
              </svg>
              <div className="leading-[12px] text-[11px] pt-[1px] font-medium">2.7K</div>
            </a>
            <a
              href="/login"
              className="max-w-fit whitespace-pre group/button px-4 h-[32px] flex justify-center items-center space-x-2 rounded w-full text-xs font-medium bg-zinc-100 hover:bg-zinc-50 cursor-pointer text-zinc-700 active:scale-[0.95]"
            >
              <div>Start</div>
              <div className="duration-[100ms] translate-x-[-1px] group-hover/button:translate-x-[+1px]">&rarr;</div>
            </a>
          </div>
        </div>
      </div>

      <div className="w-full flex justify-center">
        <div className="w-full max-w-[1200px] flex justify-center">
          <Routes>
            <Route
              path="/"
              element={
                <div className="min-h-[calc(100vh-48px)] w-full flex flex-col items-start px-[8px] sm:px-[36px] md:px-[72px] pt-12 sm:pt-24 pb-16 space-y-8 text-zinc-300/90">
                  <a
                    href="/blog/grpc-debugging"
                    className="w-full max-w-[36rem] bg-zinc-900/50 rounded-lg border border-zinc-900 px-8 py-6 flex flex-col space-y-4 hover:brightness-[1.10]"
                  >
                    <div className="text-[16px] font-medium text-zinc-300">gRPC debugging sucks so we fixed it</div>
                    <div className="text-[12px] text-zinc-700 font-medium flex items-center space-x-8">
                      <div className="text-zinc-700/60 leading-[0]">Sep 29, 2025</div>
                      <div className="flex items-center space-x-3">
                        <img src={AdhityaaProfilePicture} className="w-[12px] h-[12px] rounded-full" />
                        <div className="leading-[0]">Adhityaa Chandrasekar</div>
                      </div>
                    </div>
                  </a>

                  <a
                    href="/blog/http2-preface"
                    className="w-full max-w-[36rem] bg-zinc-900/50 rounded-lg border border-zinc-900 px-8 py-6 flex flex-col space-y-4 hover:brightness-[1.10]"
                  >
                    <div className="text-[16px] font-medium text-zinc-300">HTTP/2 connection preface and settings handshake</div>
                    <div className="text-[12px] text-zinc-700 font-medium flex items-center space-x-8">
                      <div className="text-zinc-700/60 leading-[0]">May 30, 2025</div>
                      <div className="flex items-center space-x-3">
                        <img src={AdhityaaProfilePicture} className="w-[12px] h-[12px] rounded-full" />
                        <div className="leading-[0]">Adhityaa Chandrasekar</div>
                      </div>
                    </div>
                  </a>

                  <div className="select-none font-mono text-[10px] text-zinc-800/80 p-8">{"// EOF"}</div>
                </div>
              }
            />

            <Route path="/http2-preface" element={<Post_250530_HTTP2Preface />} />
            <Route path="/grpc-debugging" element={<Post_250610_GRPCDebugging />} />
          </Routes>
        </div>
      </div>

      <Footer />
    </div>
  );
};
